/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:33d7ecb4-fcf9-4720-a917-f696f1c742b6",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_4sU6TydK7",
    "aws_user_pools_web_client_id": "26vkenk018rh28vt5uc61ucjf7",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://3hjtokvxkfhzhgpfcohtvbpjzu.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-fse6bhjqqfhb7b4dl66o676nkq",
    "aws_cloud_logic_custom": [
        {
            "name": "cardapi",
            "endpoint": "https://qovwqa8h57.execute-api.us-west-2.amazonaws.com/staging",
            "region": "us-west-2"
        },
        {
            "name": "newcardapi",
            "endpoint": "https://wv9uyacjjh.execute-api.us-west-2.amazonaws.com/staging",
            "region": "us-west-2"
        },
        {
            "name": "testResource",
            "endpoint": "https://uin5t8lteh.execute-api.us-west-2.amazonaws.com/staging",
            "region": "us-west-2"
        }
    ],
    "aws_dynamodb_all_tables_region": "us-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "dynamo34d0c7c8-staging",
            "region": "us-west-2"
        },
        {
            "tableName": "mycardsdynamotable-staging",
            "region": "us-west-2"
        },
        {
            "tableName": "testdb-staging",
            "region": "us-west-2"
        }
    ]
};


export default awsmobile;
